(ns ncr.manage.generic
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [cljs.pprint :as pp]
   [cljs.tools.reader.edn :as edn]
   [cljs.tools.reader.reader-types :as reader]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.etc.alert :as a]
   [ncr.backend :as b]
   [ncr.navigate :as n]
   [ncr.widgets.core :as w]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   ["react-simple-code-editor" :default editor]
   ["prismjs" :as prism]))

(defn- c-toolbar [{:keys [on-back on-save on-reload]}]
  [pf/c-toolbar
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :arrow-left
       :on-click on-back}]]

    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :content-save
       :is-disabled (nil? on-save)
       :on-click on-save}]

     [w/c-toolbar-button
      {:icon :undo
       :is-disabled (nil? on-reload)
       :on-click on-reload}]]]])

(def edn
  (clj->js
    {:comment
     {:pattern #";.*"
      :greedy true}
     :punctuation #"[{}\[\](),]"}))

(defn- pprint [in]
  (if (some? in)
    (binding [pp/*print-right-margin* 80]
      (with-out-str (pp/pprint in)))
    ""))

(defn- read-string [s]
  (let [reader (reader/string-push-back-reader s)]
    (loop [acc []]
      (let [seg (edn/read {:eof ::eof} reader)]
        (if (= seg ::eof)
          (match acc
            [single]
            single
            _
            acc)
          (recur (conj acc seg)))))))

(defn c-edit-profile [{:keys [title scope]}]
  (let
    [state
     (ps/sub-reducer-map! {:status nil}
       {::state
        (fn [_ state]
          state)

        :profile/edit
        (fn [state value]
          (assoc state :edit value :changed? true))

        :profile/set-loaded
        (fn [_ value]
          {:status :loaded
           :edit (pprint value)
           :changed? false})

        :profile/load
        (fn [state progress?]
          (go
            (u/error-m
              [loaded
               (<!
                 (b/!query
                   [:profile_cluster_read
                    {:scope scope}]))
               loaded (u/transit-read loaded)]
              (ps/pub! [:profile/set-loaded loaded])))
          (if progress?
            {:status :progress} state))})]

    (uix/with-effect []
      (ps/pub!
        [:profile/load true]))

    [:<>
     [pf/c-page-section {:class :pf-u-p-0}
      [c-toolbar
       {:on-save
        (match @state
          {:status :loaded :changed? true :edit edit}
          (fn []
            (a/!operation
              {:operation-title "Save Profile"
               :success-title "Profile Saved"
               :body title}

              (go
                (u/error-m
                  [parsed (read-string edit)
                   saved
                   (<!
                     (b/!mutation
                       [:profile_cluster_write
                        {:scope scope
                         :data
                         (u/transit-write parsed)}]))
                   saved
                   (u/transit-read saved)]

                  (ps/pub!
                    [:me/load])

                  (ps/pub!
                    [:profile/set-loaded saved])))))

          _ nil)

        :on-reload
        #(ps/pub! [:profile/load true])

        :on-back
        (let [{:keys [changed?]} @state]
          (fn [_]
            (go
              (when
                (or
                  (not changed?)
                  (<!
                    (m/!alert
                      {:title "Unsaved Data"
                       :title-icon-variant :warning
                       :actions-variant :ok-cancel
                       :body
                       [:span "Are you sure, you want to leave without saving?"]})))
                (n/back!)))))}]]

     [pf/c-page-section
      {:class :pf-u-p-sm
       :variant :light
       :is-filled true
       :has-overflow-scroll true}
      (match @state
        {:status (:or nil :progress)}
        [w/c-empty-progress {:class :pf-u-w-100} "Loading..."]

        [:error reason]
        [pf/c-alert
         {:class :pf-u-w-100
          :is-inline true
          :variant :danger
          :title (str "Profile Error: " reason)}]

        {:status :loaded :edit edit}
        [:> editor
         {:value edit
          :on-value-change
          #(ps/pub-sync!
             [:profile/edit %])
          :highlight #(prism/highlight % edn)
          :tab-size 4
          :padding "5px"
          :class [:ncr-c-code-editor :pf-c-form-control]
          :style
          {:overflow :auto
           :width "100%"
           :font-family "Fira code, Fira Mono, monospace"
           :font-size 12
           :height "100%"}}])]]))